/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardMetricsResponse } from '../models/DashboardMetricsResponse';
import type { DashboardNotificationResponse } from '../models/DashboardNotificationResponse';
import type { NotRegisteredAgentItem } from '../models/NotRegisteredAgentItem';
import type { OffenseInterventionItem } from '../models/OffenseInterventionItem';
import type { PendingValidationsResponse } from '../models/PendingValidationsResponse';
import type { SearchResultResponse } from '../models/SearchResultResponse';
import type { SectorMapItem } from '../models/SectorMapItem';
import type { SendDashboardNotificationDto } from '../models/SendDashboardNotificationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DashboardService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get dashboard metrics
     * Returns aggregated counts for users, societies, interventions, reports, and documents. Supports optional date range filtering.
     * @returns DashboardMetricsResponse Dashboard metrics returned successfully.
     * @throws ApiError
     */
    public dashboardControllerGetMetrics({
        startDate,
        endDate,
    }: {
        /**
         * Start date for filtering (ISO 8601)
         */
        startDate?: string,
        /**
         * End date for filtering (ISO 8601)
         */
        endDate?: string,
    }): CancelablePromise<DashboardMetricsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/metrics',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Search across entities
     * Search users, societies, interventions, and not-registered agents by name, label, email, or address. Optionally filter by entity type.
     * @returns SearchResultResponse Search results returned successfully.
     * @throws ApiError
     */
    public dashboardControllerSearch({
        query,
        entityType,
    }: {
        /**
         * Search query string
         */
        query: string,
        /**
         * Entity type to search within
         */
        entityType?: 'users' | 'societies' | 'interventions' | 'not-registered-agents',
    }): CancelablePromise<SearchResultResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/search',
            query: {
                'query': query,
                'entityType': entityType,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Get pending validations
     * Returns agents with pending document validation, societies pending validation, and documents pending review.
     * @returns PendingValidationsResponse Pending validations returned successfully.
     * @throws ApiError
     */
    public dashboardControllerGetPendingValidations(): CancelablePromise<PendingValidationsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/pending-validations',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Get sector map data
     * Returns all active sectors with their associated society information for map rendering.
     * @returns SectorMapItem Sector map data returned successfully.
     * @throws ApiError
     */
    public dashboardControllerGetSectorMap(): CancelablePromise<Array<SectorMapItem>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/sector-map',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Get offense interventions
     * Returns interventions where an offense was declared, with client and agent information.
     * @returns OffenseInterventionItem Offense interventions returned successfully.
     * @throws ApiError
     */
    public dashboardControllerGetOffenseInterventions(): CancelablePromise<Array<OffenseInterventionItem>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/interventions/offense',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * List all societies (Admin)
     * Returns a paginated list of societies with admin-level detail including owner info, agent count, and sector count.
     * @returns any List of societies returned successfully.
     * @throws ApiError
     */
    public dashboardControllerListSocieties({
        page = 1,
        limit = 20,
        search,
        type,
        status,
        missingSiret,
        refusedDocs,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Search by name or identifier
         */
        search?: string,
        /**
         * Filter by society type
         */
        type?: 'SECURITY' | 'INSTALLER' | 'DISTRIBUTOR',
        /**
         * Filter by society status
         */
        status?: 'PENDING' | 'WAITING_ON_INFORMATION' | 'VALIDATED' | 'REJECTED',
        /**
         * Filter societies with missing SIRET identifier
         */
        missingSiret?: boolean,
        /**
         * Filter societies with refused/denied documents
         */
        refusedDocs?: boolean,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/societies',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
                'type': type,
                'status': status,
                'missingSiret': missingSiret,
                'refusedDocs': refusedDocs,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * List all users (Admin)
     * Returns a paginated list of all users with optional role and verification status filters.
     * @returns any List of users returned successfully.
     * @throws ApiError
     */
    public dashboardControllerListUsers({
        page = 1,
        limit = 20,
        search,
        role,
        emailVerified,
        missingDocs,
        highRejection,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Search by name or email
         */
        search?: string,
        /**
         * Filter by user role
         */
        role?: 'CLIENT' | 'AGENT' | 'SOCIETY_OWNER' | 'ADMIN' | 'MUNICIPALITY',
        /**
         * Filter by email verification status
         */
        emailVerified?: 'PENDING' | 'VALIDATED' | 'DENIED' | 'NOT_UPLOADED',
        /**
         * Filter users with missing documents (agents/society owners with no uploaded documents)
         */
        missingDocs?: boolean,
        /**
         * Filter users with high document rejection rate (agents with rejected documents)
         */
        highRejection?: boolean,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/users',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
                'role': role,
                'emailVerified': emailVerified,
                'missingDocs': missingDocs,
                'highRejection': highRejection,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * List all interventions (Admin)
     * Returns a paginated list of interventions with client, agent, and society details.
     * @returns any List of interventions returned successfully.
     * @throws ApiError
     */
    public dashboardControllerListInterventions({
        page = 1,
        limit = 20,
        status,
        societyId,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Filter by intervention status
         */
        status?: 'REQUESTED' | 'WAITING_FOR_AGENT_ACCEPTATION' | 'ACCEPTED' | 'PAYMENT_IN_PROGRESS' | 'PAYMENT_DONE' | 'PAYMENT_FAILED' | 'PAYMENT_TIMED_OUT' | 'AGENT_MOVING' | 'INSPECTION_IN_PROGRESS' | 'NO_EFFRACTION' | 'EFFRACTION' | 'NO_SURVEILLANCE' | 'SURVEILLANCE_IN_PROGRESS' | 'SURVEILLANCE_DONE' | 'REPORT_IN_PROGRESS' | 'REJECTED' | 'CANCELED' | 'HIDDEN' | 'DONE' | 'PRICE_PROPOSED' | 'PRICE_ACCEPTED' | 'SURVEILLANCE_PAYMENT_IN_PROGRESS' | 'SURVEILLANCE_PAYMENT_DONE' | 'SURVEILLANCE_PAYMENT_FAILED' | 'SURVEILLANCE_PAYMENT_TIMED_OUT',
        /**
         * Filter by society ID
         */
        societyId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/interventions',
            query: {
                'page': page,
                'limit': limit,
                'status': status,
                'societyId': societyId,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * List all reports (Admin)
     * Returns a paginated list of intervention reports with intervention and society details.
     * @returns any List of reports returned successfully.
     * @throws ApiError
     */
    public dashboardControllerListReports({
        page = 1,
        limit = 20,
        societyId,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Filter by society ID
         */
        societyId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/reports',
            query: {
                'page': page,
                'limit': limit,
                'societyId': societyId,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * List not-registered agents
     * Returns agent profiles awaiting registration (userId IS NULL). Admin only.
     * @returns NotRegisteredAgentItem List of not-registered agents.
     * @throws ApiError
     */
    public dashboardControllerListNotRegisteredAgents({
        search,
    }: {
        /**
         * Search by name, email, or phone
         */
        search?: string,
    }): CancelablePromise<Array<NotRegisteredAgentItem>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/not-registered-agents',
            query: {
                'search': search,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Send notifications to users (Admin)
     * Sends an email and/or FCM push notification to each specified user. Emails are always sent when htmlBody is provided. Push notifications are sent when sendPush is true. Returns combined counts for both channels.
     * @returns DashboardNotificationResponse Notifications processed. Includes email and push counts.
     * @throws ApiError
     */
    public dashboardControllerSendNotifications({
        requestBody,
    }: {
        requestBody: SendDashboardNotificationDto,
    }): CancelablePromise<DashboardNotificationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/dashboard/notifications/send',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
}
